import { styled } from "@vw-marketing/us-components";

export const StyledPhoneFormWrapper: any = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 100%;
  margin-top: ${(props) => props.theme.size.static400};
`;

export const StyledPhoneInfoContainer: any = styled.div`
  padding-top: ${({ theme }) => theme.size.static250};
  width: 100%;
`;

export const StyledButtonContainer: any = styled.div`
  padding-top: ${({ theme }) => theme.size.static350};
  width: 100%;
`;